import React from "react";
import Navbar2 from "../Components/Navbar2";
import Photos from "../Components/Photos";
import Footer from "../Components/Footer";
import VideoBanner from "../Components/VideoBanner"

function Complex() {
  return (
    <div>
      <Navbar2 />
      <div className='container-fluid px-0 pb-4 pt-5'>
        <div className='h1 text-center'>
          COMPLEX SHOWCASE
        </div>
      </div>
      <VideoBanner />
      <div className="pb-3">
        <Photos />
      </div>
      <Footer />
    </div>
);
}

export default Complex;
